import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { GoogleMap, MarkerF, DirectionsRenderer, InfoWindowF, MarkerClustererF, useLoadScript } from '@react-google-maps/api';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { Icon } from '@eir/ui';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject$b;
var GlobalStyle = createGlobalStyle(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n\n* {\n  outline: none;\n  box-sizing: border-box;\n  margin: 0;\n}\n\nhtml {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 16px;\n  color: #444;\n  width: 100%;\n}\n\nbutton {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 1rem;\n}\n\na {\n  color: #288ce4;\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n"])));

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3c!--! Font Awesome Pro 6.2.0 by %40fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons%2c Inc. --%3e%3cpath fill='%23252555' d='M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM104 432c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z'/%3e%3c/svg%3e";

var _templateObject$a;
var ActionButton = styled.button(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  color: #288ce4;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:disabled {\n    text-decoration: none;\n    opacity: 0.6;\n  }\n"])));

var ShowInGoogleMaps = function ShowInGoogleMaps(_ref) {
  var route = _ref.route;

  var handleSendRouteToGooleMapClick = function handleSendRouteToGooleMapClick() {
    window.open("https://www.google.com/maps/dir/?api=1&origin=".concat(encodeURI(route.legs[0].start_address), "&destination=").concat(encodeURI(route.legs[0].end_address), "&travelmode=driving"), '_blank');
  };

  return /*#__PURE__*/jsx(ActionButton, {
    type: "button",
    onClick: handleSendRouteToGooleMapClick,
    children: "Visa i Google Maps"
  });
};

var _templateObject$9;

var MarkerInfo = function MarkerInfo(_ref) {
  var workshop = _ref.workshop,
      fetchDirections = _ref.fetchDirections,
      directions = _ref.directions,
      currentLocation = _ref.currentLocation,
      getDistance = _ref.getDistance;

  var handleGetRouteClick = function handleGetRouteClick(e) {
    e.stopPropagation();
    fetchDirections(workshop);
  };

  return /*#__PURE__*/jsxs(InfoContainer$1, {
    children: [/*#__PURE__*/jsx("header", {
      children: /*#__PURE__*/jsx("h3", {
        children: workshop.name
      })
    }), /*#__PURE__*/jsxs("main", {
      children: [currentLocation && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: "faRoute"
        }), /*#__PURE__*/jsxs("span", {
          children: [(directions === null || directions === void 0 ? void 0 : directions.workshopKey) === workshop.key ? /*#__PURE__*/jsxs(Fragment, {
            children: [directions.directions.routes[0].legs[0].distance.text, ",", ' ', directions.directions.routes[0].legs[0].duration.text]
          }) : /*#__PURE__*/jsxs(Fragment, {
            children: [(getDistance(workshop.key).distance / 1000).toLocaleString('sv-SE', {
              maximumFractionDigits: 1,
              minimumFractionDigits: 1
            }), ' ', "km"]
          }), ' ', (directions === null || directions === void 0 ? void 0 : directions.workshopKey) !== workshop.key && /*#__PURE__*/jsx(ActionButton, {
            onClick: handleGetRouteClick,
            children: "Visa v\xE4gbeskrivning"
          }), (directions === null || directions === void 0 ? void 0 : directions.workshopKey) === workshop.key && /*#__PURE__*/jsx(ShowInGoogleMaps, {
            type: "button",
            route: directions.directions.routes[0]
          })]
        })]
      }), /*#__PURE__*/jsx(Icon, {
        iconName: "faLocationDot"
      }), /*#__PURE__*/jsxs("span", {
        children: [workshop.street, ", ", workshop.city]
      }), (workshop === null || workshop === void 0 ? void 0 : workshop.phone) && workshop.phone.length > 0 && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: "faPhone"
        }), /*#__PURE__*/jsx("a", {
          href: "tel:".concat(workshop.phone),
          children: workshop.phone
        })]
      }), (workshop === null || workshop === void 0 ? void 0 : workshop.email) && workshop.email.length > 0 && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: "faAt"
        }), /*#__PURE__*/jsx("a", {
          href: "mailto:".concat(workshop.email),
          children: workshop.email
        })]
      }), (workshop === null || workshop === void 0 ? void 0 : workshop.web) && workshop.web.length > 0 && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: "faEarthEurope"
        }), /*#__PURE__*/jsx("a", {
          href: workshop.web,
          target: "_blank",
          rel: "noreferrer",
          children: workshop.web
        })]
      }), (workshop === null || workshop === void 0 ? void 0 : workshop.info) && workshop.info.length > 0 && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: "faCircleInfo"
        }), /*#__PURE__*/jsx("span", {})]
      })]
    })]
  });
};
var InfoContainer$1 = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  main {\n    display: grid;\n    grid-template-columns: min-content auto;\n    gap: 0.5rem;\n    align-items: center;\n\n    a,\n    span {\n      justify-self: flex-start;\n    }\n  }\n"])));

var Map = function Map(_ref) {
  var isLoaded = _ref.isLoaded,
      center = _ref.center,
      onLoad = _ref.onLoad,
      options = _ref.options,
      workshops = _ref.workshops,
      currentLocation = _ref.currentLocation,
      directions = _ref.directions,
      selectedMarker = _ref.selectedMarker,
      setSelectedMarker = _ref.setSelectedMarker,
      fetchDirections = _ref.fetchDirections,
      distances = _ref.distances;

  var handleMarkerClick = function handleMarkerClick(workshop) {
    return function () {
      return setSelectedMarker(workshop);
    };
  };

  var getDistanceToWorkshop = function getDistanceToWorkshop(workshopKey) {
    if (!distances) return null;
    return distances.find(function (distance) {
      return distance.workshopKey === workshopKey;
    });
  };

  return isLoaded ? /*#__PURE__*/jsxs(GoogleMap, {
    zoom: 5,
    center: center,
    mapContainerStyle: {
      width: '100%',
      height: '100%'
    },
    options: options,
    onLoad: onLoad,
    children: [currentLocation && /*#__PURE__*/jsx(MarkerF, {
      position: currentLocation
    }), directions && /*#__PURE__*/jsx(DirectionsRenderer, {
      directions: directions.directions
    }), selectedMarker ? /*#__PURE__*/jsx(InfoWindowF, {
      position: selectedMarker.position,
      onCloseClick: function onCloseClick() {
        return setSelectedMarker(null);
      },
      children: /*#__PURE__*/jsx(MarkerInfo, {
        workshop: selectedMarker,
        fetchDirections: fetchDirections,
        directions: directions,
        currentLocation: currentLocation,
        getDistance: getDistanceToWorkshop
      })
    }) : null, /*#__PURE__*/jsx(MarkerClustererF, {
      children: function children(clusterer) {
        return Object.values(workshops).map(function (workshop) {
          return /*#__PURE__*/jsx(MarkerF, {
            position: workshop.position,
            clusterer: clusterer,
            icon: {
              url: img,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
              scaledSize: new window.google.maps.Size(30, 30)
            },
            onClick: handleMarkerClick(workshop)
          }, workshop.key);
        });
      }
    })]
  }) : /*#__PURE__*/jsx("div", {
    children: "Laddar karta"
  });
};

var useClickOutside = function useClickOutside(ref, callback) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      executeCallback = _useState2[0],
      setExecuteCallback = _useState2[1];

  var handleClick = function handleClick(e) {
    if (executeCallback && ref.current && !ref.current.contains(e.target)) {
      callback(executeCallback);
    }
  };

  useEffect(function () {
    document.addEventListener('click', handleClick);
    return function () {
      return document.removeEventListener('click', handleClick);
    };
  }, [executeCallback]);
  return {
    setExecuteCallback: setExecuteCallback
  };
};

var _templateObject$8, _templateObject2$5, _templateObject3$4;
var SuggestedPlace = function SuggestedPlace(_ref) {
  var suggestion = _ref.suggestion,
      onSelectSuggestion = _ref.onSelectSuggestion;
  return /*#__PURE__*/jsxs(PlaceItem, {
    onClick: onSelectSuggestion(suggestion),
    children: [/*#__PURE__*/jsx(Strong, {
      children: suggestion.structured_formatting.main_text
    }), /*#__PURE__*/jsx(Small, {
      children: suggestion.structured_formatting.secondary_text
    })]
  });
};
var PlaceItem = styled.li(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  line-height: 1;\n  padding: 0.5rem;\n  margin: 0 -0.5rem;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #fafafa;\n  }\n"])));
var Strong = styled.span(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  font-weight: 500;\n"])));
var Small = styled.span(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  font-weight: 300;\n"])));

var _templateObject$7, _templateObject2$4, _templateObject3$3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var Search = function Search(_ref) {
  var setCurrentLocation = _ref.setCurrentLocation,
      panToLocation = _ref.panToLocation;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFetchingCurrentPosition = _useState2[0],
      setIsFetchingCurrentPosition = _useState2[1];

  var ref = useRef(null);
  useClickOutside(ref, function () {
    clearSuggestions();
  });

  var _usePlacesAutocomplet = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: {
        country: ['se']
      }
    },
    debounce: 300
  }),
      value = _usePlacesAutocomplet.value,
      _usePlacesAutocomplet2 = _usePlacesAutocomplet.suggestions,
      status = _usePlacesAutocomplet2.status,
      data = _usePlacesAutocomplet2.data,
      setValue = _usePlacesAutocomplet.setValue,
      clearSuggestions = _usePlacesAutocomplet.clearSuggestions;

  var handleInput = function handleInput(event) {
    return setValue(event.target.value);
  };

  var handleSelect = function handleSelect(_ref2) {
    var description = _ref2.description;
    return function () {
      setValue(description, false);
      clearSuggestions();
      getGeocode({
        address: description
      }).then(function (results) {
        var _getLatLng = getLatLng(results[0]),
            lat = _getLatLng.lat,
            lng = _getLatLng.lng;

        setCurrentLocation({
          lat: lat,
          lng: lng
        });
        panToLocation({
          lat: lat,
          lng: lng
        });
      });
    };
  };

  return /*#__PURE__*/jsxs(SearchWrapper, {
    children: [/*#__PURE__*/jsxs(InputWrapper, {
      children: [/*#__PURE__*/jsx("input", {
        type: "text",
        placeholder: "Ange din adress",
        value: value,
        onChange: handleInput,
        disabled: isFetchingCurrentPosition
      }), isFetchingCurrentPosition ? /*#__PURE__*/jsx(IsFetchingButton, {
        type: "button",
        disabled: true,
        children: /*#__PURE__*/jsx(Icon, {
          iconName: "faCircleNotch"
        })
      }) : /*#__PURE__*/jsx(FetchButton, {
        type: "button",
        onClick: function onClick() {
          setIsFetchingCurrentPosition(true);
          navigator.geolocation.getCurrentPosition(function (position) {
            panToLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
            setCurrentLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
            setIsFetchingCurrentPosition(false);
          });
        },
        children: /*#__PURE__*/jsx(Icon, {
          iconName: "faLocationCrosshairs"
        })
      })]
    }), status === 'OK' && data.length > 0 && /*#__PURE__*/jsx(PlacesList, {
      ref: ref,
      children: data.map(function (suggestion) {
        return /*#__PURE__*/jsx(SuggestedPlace, {
          suggestion: suggestion,
          onSelectSuggestion: handleSelect
        }, suggestion.place_id);
      })
    })]
  });
};
var SearchWrapper = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var InputWrapper = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  display: flex;\n  border-radius: 0.5rem;\n  font-size: 1.2rem;\n  box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);\n  padding: 0.5rem 1rem;\n\n  input {\n    flex: 1;\n    font-size: 1rem;\n    border: 0;\n    outline: none;\n    padding: 0.25rem 0;\n\n    &:focus {\n      background-color: #fff;\n    }\n  }\n\n  button {\n    background-color: transparent;\n    border: none;\n    font-size: 1.2rem;\n    cursor: pointer;\n  }\n"])));
var PlacesList = styled.ul(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n\n  position: absolute;\n  z-index: 10;\n  margin: 0;\n  margin-top: -0.5rem;\n  padding: 0.75rem;\n  width: 100%;\n  box-shadow: 0 2px 4px rgb(0 0 0 / 20%);\n  background-color: #fff;\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n  font-family: 1rem;\n"])));
var Button = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  font-size: 1.2rem;\n"])));
var FetchButton = styled(Button)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var rotate = keyframes(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var IsFetchingButton = styled(Button)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  opacity: 0.5;\n  animation: ", " 2s linear infinite;\n"])), rotate);

var _templateObject$6;
var ListItem = styled.li(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  color: #24292f;\n  background-color: #fafafa;\n  border-radius: 0.25rem;\n  border-bottom: 0.125rem solid #e6e6e6;\n  padding: 0.5rem;\n  cursor: pointer;\n\n  header {\n    display: flex;\n    justify-content: space-between;\n\n    span {\n      white-space: nowrap;\n    }\n  }\n\n  h3 {\n    margin: 0;\n  }\n"])));

var _templateObject$5;

var DetailedWorkshopItem = function DetailedWorkshopItem(_ref) {
  var workshop = _ref.workshop,
      fetchDirections = _ref.fetchDirections,
      directions = _ref.directions,
      currentLocation = _ref.currentLocation,
      distance = _ref.distance,
      isMobileView = _ref.isMobileView,
      setToShowMapView = _ref.setToShowMapView,
      isPossibleToMinimize = _ref.isPossibleToMinimize,
      hideDetails = _ref.hideDetails,
      panToLocation = _ref.panToLocation;

  var handleItemClick = function handleItemClick() {
    isPossibleToMinimize && hideDetails();
    panToLocation(workshop.position);
  };

  var handleGetRouteClick = function handleGetRouteClick(e) {
    e.stopPropagation();
    fetchDirections(workshop);
    isMobileView && setToShowMapView();
  };

  return /*#__PURE__*/jsx(ListItem, {
    onClick: handleItemClick,
    children: /*#__PURE__*/jsxs(InfoContainer, {
      children: [/*#__PURE__*/jsx("header", {
        children: /*#__PURE__*/jsx("h3", {
          children: workshop.name
        })
      }), /*#__PURE__*/jsxs("main", {
        children: [currentLocation && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Icon, {
            iconName: "faRoute"
          }), /*#__PURE__*/jsxs("span", {
            children: [(directions === null || directions === void 0 ? void 0 : directions.workshopKey) === workshop.key ? /*#__PURE__*/jsxs(Fragment, {
              children: [directions.directions.routes[0].legs[0].distance.text, ",", ' ', directions.directions.routes[0].legs[0].duration.text]
            }) : /*#__PURE__*/jsxs(Fragment, {
              children: [(distance / 1000).toLocaleString('sv-SE', {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
              }), ' ', "km"]
            }), ' ', (directions === null || directions === void 0 ? void 0 : directions.workshopKey) !== workshop.key && /*#__PURE__*/jsx(ActionButton, {
              onClick: handleGetRouteClick,
              children: "Visa v\xE4gbeskrivning"
            }), (directions === null || directions === void 0 ? void 0 : directions.workshopKey) === workshop.key && /*#__PURE__*/jsx(ShowInGoogleMaps, {
              type: "button",
              route: directions.directions.routes[0]
            })]
          })]
        }), /*#__PURE__*/jsx(Icon, {
          iconName: "faLocationDot"
        }), /*#__PURE__*/jsxs("span", {
          children: [workshop.street, ", ", workshop.city]
        }), (workshop === null || workshop === void 0 ? void 0 : workshop.phone) && workshop.phone.length > 0 && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Icon, {
            iconName: "faPhone"
          }), /*#__PURE__*/jsx("a", {
            href: "tel:".concat(workshop.phone),
            children: workshop.phone
          })]
        }), (workshop === null || workshop === void 0 ? void 0 : workshop.email) && workshop.email.length > 0 && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Icon, {
            iconName: "faAt"
          }), /*#__PURE__*/jsx("a", {
            href: "mailto:".concat(workshop.email),
            children: workshop.email
          })]
        }), (workshop === null || workshop === void 0 ? void 0 : workshop.web) && workshop.web.length > 0 && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Icon, {
            iconName: "faEarthEurope"
          }), /*#__PURE__*/jsx("a", {
            href: workshop.web,
            target: "_blank",
            rel: "noreferrer",
            children: workshop.web
          })]
        }), (workshop === null || workshop === void 0 ? void 0 : workshop.info) && workshop.info.length > 0 && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Icon, {
            iconName: "faCircleInfo"
          }), /*#__PURE__*/jsx("span", {})]
        })]
      })]
    })
  });
};
var InfoContainer = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  main {\n    display: grid;\n    grid-template-columns: min-content auto;\n    gap: 0.5rem;\n    align-items: center;\n\n    a,\n    span {\n      justify-self: flex-start;\n    }\n  }\n"])));

var MinimizedWorkshopItem = function MinimizedWorkshopItem(_ref) {
  var workshop = _ref.workshop,
      panToLocation = _ref.panToLocation,
      distance = _ref.distance,
      showDetails = _ref.showDetails;

  var handleItemClick = function handleItemClick() {
    showDetails();
    panToLocation(workshop.position);
  };

  return /*#__PURE__*/jsx(ListItem, {
    onClick: handleItemClick,
    children: /*#__PURE__*/jsxs("header", {
      children: [/*#__PURE__*/jsx("h3", {
        children: workshop.name
      }), distance && /*#__PURE__*/jsxs("span", {
        children: [(distance / 1000).toLocaleString('sv-SE', {
          maximumFractionDigits: 1,
          minimumFractionDigits: 1
        }), ' ', "km"]
      })]
    })
  });
};

var WorkshopItem = function WorkshopItem(_ref) {
  var workshop = _ref.workshop,
      fetchDirections = _ref.fetchDirections,
      panToLocation = _ref.panToLocation,
      showDetailed = _ref.showDetailed,
      directions = _ref.directions,
      currentLocation = _ref.currentLocation,
      distance = _ref.distance,
      isMobileView = _ref.isMobileView,
      setToShowMapView = _ref.setToShowMapView,
      _ref$isPossibleToMini = _ref.isPossibleToMinimize,
      isPossibleToMinimize = _ref$isPossibleToMini === void 0 ? false : _ref$isPossibleToMini;

  var _useState = useState(showDetailed),
      _useState2 = _slicedToArray(_useState, 2),
      isShowingDetailed = _useState2[0],
      setIsShowingDetailed = _useState2[1];

  var hideDetails = function hideDetails() {
    return setIsShowingDetailed(false);
  };

  var showDetails = function showDetails() {
    return setIsShowingDetailed(true);
  };

  return isShowingDetailed ? /*#__PURE__*/jsx(DetailedWorkshopItem, {
    workshop: workshop,
    directions: directions,
    fetchDirections: fetchDirections,
    currentLocation: currentLocation,
    distance: distance,
    isMobileView: isMobileView,
    setToShowMapView: setToShowMapView,
    isPossibleToMinimize: isPossibleToMinimize,
    hideDetails: hideDetails,
    panToLocation: panToLocation
  }) : /*#__PURE__*/jsx(MinimizedWorkshopItem, {
    workshop: workshop,
    panToLocation: panToLocation,
    showDetails: showDetails
  });
};

var _templateObject$4, _templateObject2$3;

var Workshops = function Workshops(_ref) {
  var workshops = _ref.workshops,
      distances = _ref.distances,
      directions = _ref.directions,
      panToLocation = _ref.panToLocation,
      fetchDirections = _ref.fetchDirections,
      currentLocation = _ref.currentLocation,
      isMobileView = _ref.isMobileView,
      setToShowMapView = _ref.setToShowMapView;
  return /*#__PURE__*/jsx(ListsWrapper, {
    children: distances ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("h3", {
        children: "Verkst\xE4der n\xE4rmast dig"
      }), /*#__PURE__*/jsxs(WorkshopsList, {
        children: [distances.slice(0, 5).map(function (distanceToWorkshop) {
          var workshop = Object.values(workshops).find(function (workshop) {
            return workshop.key === distanceToWorkshop.workshopKey;
          });
          return workshop && /*#__PURE__*/jsx(WorkshopItem, {
            workshop: workshop,
            distance: distanceToWorkshop.distance,
            fetchDirections: fetchDirections,
            panToLocation: panToLocation,
            showDetailed: true,
            directions: directions,
            currentLocation: currentLocation,
            isMobileView: isMobileView,
            setToShowMapView: setToShowMapView
          }, workshop.key);
        }), /*#__PURE__*/jsx("h3", {
          children: "V\xE5ra \xF6vriga avtalsverkst\xE4der"
        })]
      }), /*#__PURE__*/jsx(WorkshopsList, {
        children: distances.slice(5).map(function (distanceToWorkshop) {
          var workshop = Object.values(workshops).find(function (workshop) {
            return workshop.key === distanceToWorkshop.workshopKey;
          });
          return workshop && /*#__PURE__*/jsx(WorkshopItem, {
            workshop: workshop,
            distance: distanceToWorkshop.distance,
            fetchDirections: fetchDirections,
            panToLocation: panToLocation,
            showDetailed: false,
            isPossibleToMinimize: true,
            directions: directions,
            isMobileView: isMobileView,
            setToShowMapView: setToShowMapView,
            currentLocation: currentLocation
          }, workshop.key);
        })
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("h3", {
        children: "V\xE5ra avtalsverkst\xE4der"
      }), /*#__PURE__*/jsx(WorkshopsList, {
        children: workshops && Object.values(workshops).map(function (workshop) {
          return /*#__PURE__*/jsx(WorkshopItem, {
            workshop: workshop,
            fetchDirections: fetchDirections,
            panToLocation: panToLocation,
            showDetailed: false,
            isPossibleToMinimize: true
          }, workshop.key);
        })
      })]
    })
  });
};
var WorkshopsList = styled.ul(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 0;\n"])));
var ListsWrapper = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem 0.5rem;\n"])));

var _templateObject$3, _templateObject2$2, _templateObject3$2;

var DesktopView = function DesktopView(_ref) {
  var isLoaded = _ref.isLoaded,
      center = _ref.center,
      onLoad = _ref.onLoad,
      options = _ref.options,
      workshops = _ref.workshops,
      distances = _ref.distances,
      directions = _ref.directions,
      fetchDirections = _ref.fetchDirections,
      currentLocation = _ref.currentLocation,
      setCurrentLocation = _ref.setCurrentLocation,
      panToLocation = _ref.panToLocation,
      selectedMarker = _ref.selectedMarker,
      setSelectedMarker = _ref.setSelectedMarker;
  return /*#__PURE__*/jsxs(Wrapper$1, {
    children: [/*#__PURE__*/jsxs(Aside, {
      children: [/*#__PURE__*/jsx(Search, {
        setCurrentLocation: setCurrentLocation,
        panToLocation: panToLocation
      }), /*#__PURE__*/jsx("section", {
        children: /*#__PURE__*/jsx(Workshops, {
          workshops: workshops,
          distances: distances,
          fetchDirections: fetchDirections,
          currentLocation: currentLocation,
          directions: directions,
          isMobileView: false,
          panToLocation: panToLocation
        })
      })]
    }), /*#__PURE__*/jsx(Main$1, {
      children: /*#__PURE__*/jsx(Map, {
        isLoaded: isLoaded,
        center: center,
        onLoad: onLoad,
        options: options,
        workshops: workshops,
        directions: directions,
        fetchDirections: fetchDirections,
        currentLocation: currentLocation,
        distances: distances,
        selectedMarker: selectedMarker,
        setSelectedMarker: setSelectedMarker
      })
    })]
  });
};
var Wrapper$1 = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  display: flex;\n  height: 100%;\n"])));
var Aside = styled.aside(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  width: 24rem;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background-color: #fff;\n  padding: 1rem 0.5rem;\n  border-right: 0.0625rem solid #c0c0c0;\n\n  section {\n    overflow: auto;\n  }\n"])));
var Main$1 = styled.main(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));

var _templateObject$2, _templateObject2$1, _templateObject3$1;

var MobileFooter = function MobileFooter(_ref) {
  var showMapView = _ref.showMapView,
      toggleView = _ref.toggleView,
      directions = _ref.directions;
  return /*#__PURE__*/jsxs(Footer, {
    children: [/*#__PURE__*/jsx(ToggleButton, {
      type: "button",
      onClick: toggleView,
      children: showMapView ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: "faList"
        }), /*#__PURE__*/jsx("span", {
          children: "Visa lista"
        })]
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Icon, {
          iconName: "faMapLocationDot"
        }), /*#__PURE__*/jsx("span", {
          children: "Visa karta"
        })]
      })
    }), showMapView && directions && /*#__PURE__*/jsx(ShowInGoogleMapsWrapper, {
      children: /*#__PURE__*/jsx(ShowInGoogleMaps, {
        route: directions.directions.routes[0]
      })
    })]
  });
};
var Footer = styled.footer(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 0.125rem solid #ccc;\n"])));
var ToggleButton = styled.button(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: transparent;\n  color: #000;\n  border: none;\n  padding: 1rem;\n  cursor: pointer;\n\n  span {\n    font-size: 0.625rem;\n  }\n"])));
var ShowInGoogleMapsWrapper = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  padding-right: 1rem;\n"])));

var _templateObject$1, _templateObject2, _templateObject3;

var MobileView = function MobileView(_ref) {
  var isLoaded = _ref.isLoaded,
      center = _ref.center,
      onLoad = _ref.onLoad,
      options = _ref.options,
      workshops = _ref.workshops,
      currentLocation = _ref.currentLocation,
      setCurrentLocation = _ref.setCurrentLocation,
      panToLocation = _ref.panToLocation,
      distances = _ref.distances,
      directions = _ref.directions,
      fetchDirections = _ref.fetchDirections,
      selectedMarker = _ref.selectedMarker,
      setSelectedMarker = _ref.setSelectedMarker;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showMapView = _useState2[0],
      setShowMapView = _useState2[1];

  var toggleView = function toggleView() {
    return setShowMapView(!showMapView);
  };

  var setToShowMapView = function setToShowMapView() {
    return setShowMapView(true);
  };

  return /*#__PURE__*/jsxs(Wrapper, {
    children: [/*#__PURE__*/jsx(Header, {
      children: /*#__PURE__*/jsx(Search, {
        setCurrentLocation: setCurrentLocation,
        panToLocation: panToLocation
      })
    }), /*#__PURE__*/jsx(Main, {
      children: isLoaded && showMapView ? /*#__PURE__*/jsx(Map, {
        isLoaded: isLoaded,
        center: center,
        onLoad: onLoad,
        options: options,
        workshops: workshops,
        currentLocation: currentLocation,
        directions: directions,
        fetchDirections: fetchDirections,
        selectedMarker: selectedMarker,
        setSelectedMarker: setSelectedMarker,
        distances: distances
      }) : /*#__PURE__*/jsx(Workshops, {
        workshops: workshops,
        distances: distances,
        fetchDirections: fetchDirections,
        currentLocation: currentLocation,
        directions: directions,
        isMobileView: true,
        setToShowMapView: setToShowMapView,
        panToLocation: panToLocation
      })
    }), /*#__PURE__*/jsx(MobileFooter, {
      showMapView: showMapView,
      toggleView: toggleView,
      directions: directions
    })]
  });
};
var Wrapper = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var Header = styled.header(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0.5rem;\n"])));
var Main = styled.main(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  overflow: auto;\n"])));

var _templateObject;
var LIBRARIES = ['places', 'geometry'];

var WorkShopsOnMap = function WorkShopsOnMap() {
  var _useLoadScript = useLoadScript({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES
  }),
      isLoaded = _useLoadScript.isLoaded;

  var _useState = useState({
    width: 0,
    height: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      componentDimensions = _useState2[0],
      setComponentDimensions = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      currentLocation = _useState4[0],
      setCurrentLocation = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      workshops = _useState6[0],
      setWorkshops = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      distanceToWorkShops = _useState8[0],
      setDistanceToWorkShops = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      directions = _useState10[0],
      setDirections = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      selectedMarker = _useState12[0],
      setSelectedMarker = _useState12[1];

  var wrapperRef = useRef(null);
  var mapRef = useRef();
  var mapCenter = useMemo(function () {
    return {
      lat: 62.38671949383487,
      lng: 16.321305998880558
    };
  }, []);
  var mapOptions = useMemo(function () {
    return {
      clickableIcons: false,
      disableDefaultUI: true,
      zoomControl: true,
      mapId: '15906646db21947a'
    };
  }, []);
  var onLoad = useCallback(function (map) {
    mapRef.current = map;
  }, []);
  var panToLocation = useCallback(function (_ref) {
    var lat = _ref.lat,
        lng = _ref.lng;
    mapRef.current.panTo({
      lat: lat,
      lng: lng
    });
    mapRef.current.setZoom(14);
  }, []);

  var setDimensions = function setDimensions() {
    if (wrapperRef.current) {
      setComponentDimensions({
        width: wrapperRef.current.offsetWidth,
        height: window.innerHeight
      });
    }
  };

  useEffect(function () {
    setDimensions();
    window.addEventListener('resize', setDimensions);
    return function () {
      window.removeEventListener('resize', setDimensions);
    };
  }, []);
  useEffect(function () {
    fetch('https://d2l0gvltru79ov.cloudfront.net/claims/workshops.json').then(function (response) {
      return response.json();
    }).then(function (data) {
      return setWorkshops(data);
    });
  }, []);
  useEffect(function () {
    if (currentLocation) {
      // eslint-disable-next-line no-undef
      var origin = new google.maps.LatLng(currentLocation.lat, currentLocation.lng);

      var _distanceToWorkShops = Object.values(workshops).reduce(function (a, b) {
        /* eslint-disable no-undef */
        var destination = new google.maps.LatLng(b.position.lat, b.position.lng);
        var distance = google.maps.geometry.spherical.computeDistanceBetween(origin, destination);
        /* eslint-enable no-undef */

        a.push({
          workshopKey: b.key,
          distance: distance
        });
        return a;
      }, []).sort(function (a, b) {
        return a.distance > b.distance ? 1 : -1;
      });

      setDistanceToWorkShops(_distanceToWorkShops);
    }
  }, [currentLocation]);

  var fetchDirections = function fetchDirections(workshop) {
    if (!currentLocation) return; // eslint-disable-next-line no-undef

    var service = new google.maps.DirectionsService();
    service.route({
      origin: currentLocation,
      destination: workshop.position,
      travelMode: google.maps.TravelMode.DRIVING // eslint-disable-line no-undef

    }, function (result, status) {
      if (status === 'OK' && result) {
        setDirections({
          directions: result,
          workshopKey: workshop.key
        });
      }
    });
  };

  return /*#__PURE__*/jsxs(ViewWrapper, {
    ref: wrapperRef,
    wrapperHeight: componentDimensions.height,
    children: [/*#__PURE__*/jsx(GlobalStyle, {}), isLoaded && (componentDimensions.width <= 900 ? /*#__PURE__*/jsx(MobileView, {
      isLoaded: isLoaded,
      center: mapCenter,
      onLoad: onLoad,
      options: mapOptions,
      workshops: workshops,
      currentLocation: currentLocation,
      setCurrentLocation: setCurrentLocation,
      panToLocation: panToLocation,
      distances: distanceToWorkShops,
      directions: directions,
      fetchDirections: fetchDirections,
      selectedMarker: selectedMarker,
      setSelectedMarker: setSelectedMarker
    }) : /*#__PURE__*/jsx(DesktopView, {
      isLoaded: isLoaded,
      center: mapCenter,
      onLoad: onLoad,
      options: mapOptions,
      workshops: workshops,
      currentLocation: currentLocation,
      setCurrentLocation: setCurrentLocation,
      panToLocation: panToLocation,
      distances: distanceToWorkShops,
      directions: directions,
      fetchDirections: fetchDirections,
      selectedMarker: selectedMarker,
      setSelectedMarker: setSelectedMarker
    }))]
  });
};
var ViewWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", "px;\n"])), function (_ref2) {
  var wrapperHeight = _ref2.wrapperHeight;
  return wrapperHeight;
});

export { WorkShopsOnMap as WorkshopsOnMap };
